// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ofertas-usuario .contenido-principal{ 
    gap: 100px;
    margin-top: 30px;
}

.ofertas-usuario .cabecera{margin-bottom: 0px;}
.contenido-pestanas{ white-space: pre-line; }


/* -----------------------------------------------------------------------------
// CAJA CON CARACTERISTICAS PRINCIPALES - EMPLEO, FORMACIÓN Y RECURSO SOCIAL
// ----------------------------------------------------------------------------- */
.ofertas-usuario .caracteristicas{ width: 422.2px; }
.ofertas-usuario .caracteristicas p{ 
    display: flex; 
    align-items: center; 
    gap: 8px;
    margin-bottom: 8px;
}
.ofertas-usuario .caracteristicas span{ 
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
}
.ofertas-usuario .caracteristicas svg{ 
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    display: inline-block;
}
.ofertas-usuario .caracteristicas a{ 
    display: flex; 
    align-items: center; 
    gap: 8px;
    text-decoration: none;
    margin-bottom: 8px;
}


/* -----------------------------------------------------------------------------
// CAJA CON CARACTERISTICAS PRINCIPALES - RECURSO
// ----------------------------------------------------------------------------- */
.ofertas-usuario .contenido-principal.recurso{ max-width: 850px; gap: 20px; }

.ofertas-usuario .contenido-principal.recurso .boton{ 
    display: block;  
    width: fit-content;
    padding: 7px 15px;
}

.ofertas-usuario .contenido-principal.recurso .boton.rosa{ border: 2px solid #b90248; }
.ofertas-usuario .contenido-principal.recurso .boton.rosa:hover{ background-color:  #b90248; }

.ofertas-usuario .contenido-principal.recurso .boton.azul{ border: 2px solid #3C4A99; }
.ofertas-usuario .contenido-principal.recurso .boton.azul:hover{ background-color:  #3C4A99; }


/* -----------------------------------------------------------------------------
// BOTÓN ELIMINAR 
// ----------------------------------------------------------------------------- */
.ofertas-usuario .eliminar{
    padding: 10px 15px;
    border: 2px solid #8E151D;
    border-radius: 12px;
    height: fit-content;
}

.ofertas-usuario .eliminar:hover{
    background-color: black;
    border: 2px solid black;
}`, "",{"version":3,"sources":["webpack://./src/pages/user/css/NuevosRecursos.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA,2BAA2B,kBAAkB,CAAC;AAC9C,qBAAqB,qBAAqB,EAAE;;;AAG5C;;kFAEkF;AAClF,mCAAmC,cAAc,EAAE;AACnD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,kBAAkB;AACtB;;;AAGA;;kFAEkF;AAClF,+CAA+C,gBAAgB,EAChB,SAAS,EADS;;AAGjE;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,2DAA2D,yBAAyB,EAAE;AACtF,iEAAiE,0BAA0B,EAAE;;AAE7F,2DAA2D,yBAAyB,EAAE;AACtF,iEAAiE,0BAA0B,EAAE;;;AAG7F;;kFAEkF;AAClF;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B","sourcesContent":[".ofertas-usuario .contenido-principal{ \n    gap: 100px;\n    margin-top: 30px;\n}\n\n.ofertas-usuario .cabecera{margin-bottom: 0px;}\n.contenido-pestanas{ white-space: pre-line; }\n\n\n/* -----------------------------------------------------------------------------\n// CAJA CON CARACTERISTICAS PRINCIPALES - EMPLEO, FORMACIÓN Y RECURSO SOCIAL\n// ----------------------------------------------------------------------------- */\n.ofertas-usuario .caracteristicas{ width: 422.2px; }\n.ofertas-usuario .caracteristicas p{ \n    display: flex; \n    align-items: center; \n    gap: 8px;\n    margin-bottom: 8px;\n}\n.ofertas-usuario .caracteristicas span{ \n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n.ofertas-usuario .caracteristicas svg{ \n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n}\n.ofertas-usuario .caracteristicas a{ \n    display: flex; \n    align-items: center; \n    gap: 8px;\n    text-decoration: none;\n    margin-bottom: 8px;\n}\n\n\n/* -----------------------------------------------------------------------------\n// CAJA CON CARACTERISTICAS PRINCIPALES - RECURSO\n// ----------------------------------------------------------------------------- */\n.ofertas-usuario .contenido-principal.recurso{ max-width: 850px; }\n.ofertas-usuario .contenido-principal.recurso{ gap: 20px; }\n\n.ofertas-usuario .contenido-principal.recurso .boton{ \n    display: block;  \n    width: fit-content;\n    padding: 7px 15px;\n}\n\n.ofertas-usuario .contenido-principal.recurso .boton.rosa{ border: 2px solid #b90248; }\n.ofertas-usuario .contenido-principal.recurso .boton.rosa:hover{ background-color:  #b90248; }\n\n.ofertas-usuario .contenido-principal.recurso .boton.azul{ border: 2px solid #3C4A99; }\n.ofertas-usuario .contenido-principal.recurso .boton.azul:hover{ background-color:  #3C4A99; }\n\n\n/* -----------------------------------------------------------------------------\n// BOTÓN ELIMINAR \n// ----------------------------------------------------------------------------- */\n.ofertas-usuario .eliminar{\n    padding: 10px 15px;\n    border: 2px solid #8E151D;\n    border-radius: 12px;\n    height: fit-content;\n}\n\n.ofertas-usuario .eliminar:hover{\n    background-color: black;\n    border: 2px solid black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
